import { resolveKeysInObjectsArrays, checkUserLogin } from 'AccountsUtils'
import { triggerClevertap } from '../../utils'

// eslint-disable-next-line import/prefer-default-export
export const triggerHiFiveClevertap = (payload = {}, eventName = 'Air_UI_Action') => {
  const getCookie = cname => {
    const name = `${cname}=`
    const ca = document.cookie.split(';')
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i]
      while (c.charAt(0) === ' ') {
        c = c.substring(1)
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length)
      }
    }
    return ''
  }
  const commonParams = {
    domain: resolveKeysInObjectsArrays(['location', 'hostname'], window),
    platform: 'Desktop'
  }
  if (checkUserLogin()) {
    const userIdCookie = getCookie('userid')
    const userId = decodeURIComponent(userIdCookie).split('|')[4]
    commonParams.user_id = userId
  }
  triggerClevertap(eventName, {
    ...payload,
    ...commonParams
  })
}
